import { c as _c } from "react/compiler-runtime";
import { IcoUser16 } from '@onefootprint/icons';
import { Position } from '@xyflow/react';
import { cx } from 'class-variance-authority';
import useNodeContext from '../../hooks/use-node-context';
import type { NodeProps } from '../../playbook-builder.types';
import CustomHandle from '../custom-handle';
const BoKycNode = t0 => {
  const $ = _c(17);
  const {
    id,
    selected,
    data
  } = t0;
  const width = Number(data?.width) || 208;
  const height = Number(data?.height) || 100;
  const {
    nodeColorClassName
  } = useNodeContext(id);
  const t1 = selected && "border-accent";
  const t2 = !selected && "border-blue-100 border-dashed";
  let t3;
  if ($[0] !== nodeColorClassName || $[1] !== t1 || $[2] !== t2) {
    t3 = cx("min-w-52 relative p-4", "bg-[#EDF3FC]", "rounded border-[1.5px]", t1, t2, nodeColorClassName);
    $[0] = nodeColorClassName;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== height || $[5] !== width) {
    t4 = {
      width,
      height
    };
    $[4] = height;
    $[5] = width;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== id) {
    t5 = <CustomHandle type="target" position={Position.Top} id={id} />;
    $[7] = id;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center justify-center gap-0.5 mb-2"><IcoUser16 /><span className="text-label-2 text-primary">Business Owner KYC</span></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== id) {
    t7 = <CustomHandle type="source" position={Position.Bottom} id={id} />;
    $[10] = id;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <div className={t3} style={t4}>{t5}{t6}{t7}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default BoKycNode;